import React from 'react';
import { Typography, Image } from 'antd';
import { useTranslation } from 'react-i18next';
import { pickLang } from '../../data/pickLang';
import styles from './news.module.css';

const { Paragraph } = Typography;

const NewsContent = ({ content }) => {
  const { t, i18n } = useTranslation();

  // Check if content exists and is an array
  if (!content || !Array.isArray(content) || content.length === 0) {
    return null; // or return a default message if needed
  }

  const renderContentItem = (item, index) => {
    switch (item.type) {
      case 'text':
        return (
          <Paragraph key={index} className={styles.contentText}>
            {pickLang(item.data, i18n.language)}
          </Paragraph>
        );

      case 'image':
        return (
          <div key={index} className={styles.contentMedia}>
            <Image
              src={item.data}
              alt={item.caption || t('news.imageAlt')}
              className={styles.contentImage}
              fallback="/images/placeholder-news.svg"
            />
            {item.caption && (
              <div className={styles.mediaCaption}>{item.caption}</div>
            )}
          </div>
        );

      case 'video':
        return (
          <div key={index} className={styles.contentMedia}>
            <video
              controls
              className={styles.contentVideo}
              poster="/images/video-placeholder.jpg"
            >
              <source src={item.data} type="video/mp4" />
              {t('news.videoNotSupported')}
            </video>
            {item.caption && (
              <div className={styles.mediaCaption}>{item.caption}</div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={styles.newsContent}>
      {content.map((item, index) => renderContentItem(item, index))}
    </div>
  );
};

export default NewsContent; 